export function Avatar() {
  return (
    <svg data-user viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="var(--color-content-inverted-primary)"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16 0C24.8366 0 32 7.16344 32 16C32 20.6139 30.0471 24.7716 26.9228 27.6917C23.8934 25.3757 20.1074 24 16 24C11.8926 24 8.10659 25.3757 5.07751 27.6915C1.95292 24.7716 0 20.6139 0 16C0 7.16344 7.16344 0 16 0ZM16 8C12.6863 8 10 10.6863 10 14C10 17.3137 12.6863 20 16 20C19.3137 20 22 17.3137 22 14C22 10.6863 19.3137 8 16 8Z" fill="currentColor"/>
    </svg>
  );
}
